<template>
  <div>
    <v-container fluid>
      <v-card elevation="0">
        <v-row>
          <!--Start Top Section-->
          <v-col cols="12" md="12" lg="12" sm="12">
            <v-row>
              <v-col :class="!$vuetify.breakpoint.smAndUp ? 'pb-1' : ''" cols="12" md="6" lg="6" sm="6">
                <v-card-title class="headline">
                  {{ kit.name }}: Order History
                </v-card-title>
              </v-col>
              <v-col cols="12" md="6" lg="6" sm="6" :class="!$vuetify.breakpoint.smAndUp ? 'py-1' : ''">
                <v-card-actions class="d-flex justify-end">
                  <router-link slot="right" :to="{name: 'orderHistory'}">
                    <v-btn
                      v-if="$vuetify.breakpoint.smAndUp"
                      elevation="1"
                      right
                      small
                      dense
                      top
                    >
                      <v-icon left>mdi-arrow-left</v-icon>back</v-btn
                    >
                    <v-btn
                      v-else
                      fixed
                      right
                      fab
                      small
                      color="grey lighten-2"
                      elevation="1"
                      class="mr-n2 mt-10"
                      style="opacity: 0.6"
                    >
                      <v-icon>mdi-arrow-left</v-icon></v-btn
                    >
                  </router-link>
                </v-card-actions>
              </v-col>
            </v-row>
          </v-col>
          <!--End Top Section-->
          <!--Start Filter Section-->
          <v-col class="py-0" cols="12" md="12" lg="12" sm="12">
            <v-card-text>
              <form @submit.prevent="getOrderHistory">
                <v-row class="mt-4">
                    <v-col cols="12" md="3" lg="3" sm="3" xs=12>
                        <v-menu
                          ref="fromDateMenu"
                          v-model="fromDateMenu"
                          :close-on-content-click="false"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              class="my-0 py-1"
                              v-model="filterFromDate"
                              label="From Date"
                              prepend-icon="mdi-calendar"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="filter.orderFromDate"
                            no-title
                            scrollable
                            :max="filter.orderToDate"
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="fromDateMenu = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.fromDateMenu.save(filter.orderFromDate)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col cols="12" md="3" lg="3" sm="3" xs=12>
                        <v-menu
                          ref="toDateMenu"
                          v-model="toDateMenu"
                          :close-on-content-click="false"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              class="my-0 py-1"
                              v-model="filterToDate"
                              label="To Date"
                              prepend-icon="mdi-calendar"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="filter.orderToDate"
                            no-title
                            scrollable
                            :min="filter.orderFromDate"
                            :max="currentDate"
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="toDateMenu = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.toDateMenu.save(filter.orderToDate)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col cols="12" md="3" lg="3" sm="3" xs=12>
                        <v-autocomplete
                            label="Status"
                            class="my-0 py-1"
                            key="status"
                            v-model="filter.status"
                            :items="statusList"
                            item-text="name"
                            item-value="value"
                        />
                    </v-col>
                    <v-col
                        v-if="!$vuetify.breakpoint.xs"
                        cols="12"
                        md="3"
                        lg="3"
                        sm="12"
                    >
                      <v-card-actions class="justify-center">
                        <v-btn
                          color="#5d58ef"
                          class="white--text"
                          small
                          dense
                          type="submit"
                          width="50%"
                        >
                          <v-icon left>mdi-filter</v-icon>Apply Filter
                        </v-btn>
                        <v-btn @click="resetAll" width="50%" dense depressed small>
                          <v-icon left> mdi-restart</v-icon> Reset Filter
                        </v-btn>
                      </v-card-actions>
                    </v-col>
                    <v-col v-else cols="12" xs="12" class="px-0">
                      <v-row no-gutters>
                        <v-col class="mb-2" cols="12" xs="12">
                            <v-btn
                            color="#5d58ef"
                            class="white--text"
                            dense
                            width="100%"
                            small
                            type="submit"
                            >
                              <v-icon left>mdi-filter</v-icon>Apply Filter
                            </v-btn>
                        </v-col>
                        <v-col cols="12" xs="12">
                            <v-btn
                            depressed
                            dense
                            width="100%"
                            small
                            @click="resetAll"
                            >
                            <v-icon left> mdi-restart</v-icon> Reset Filter
                            </v-btn>
                        </v-col>
                      </v-row>
                    </v-col>
                </v-row>
              </form>
            </v-card-text>
          </v-col>
          <!--End Filter Section-->
          <v-col cols="12" md="12" lg="12" sm="12" xs="12">
            <div class="v-data-table-container">
              <v-row no-gutters>
                <v-col class="d-flex" cols="12" md="8" lg="8" sm="6" xs="12">
                  <div class="align-self-end ml-2 pl-2">Total Records : <b>{{ total }}</b></div>
                </v-col>
                <v-col cols="12" md="4" lg="4" sm="6" xs="12">
                  <v-text-field
                    v-model="searchTerm"
                    label="Search"
                    class="mx-4 mb-2"
                    hide-details
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-data-table
                class="px-4 elevation-0"
                dense
                :search="searchTerm"
                :headers="headers"
                :items="searchFilterArray"
                :footer-props="{
                  'items-per-page-options': itemsPerPageOption
                }"
                :items-per-page="perPageLimit"
                :custom-filter="customSearch"
                @pagination="checkTotalResultCount"
              >
                <template v-slot:item.preOrder = "{item}">
                  <span v-if="!item.previousOrder && !item.reOrderID">-</span>
                  <span v-if="item.previousOrder">
                    Re-order ID: {{ item.previousOrder.reOrderID.orderID }}
                  </span>
                  <span v-if="item.reOrderID">
                    Prev. order: {{ item.reOrderID.previousOrder.orderID }}
                  </span>
                </template>
                <template v-slot:item.poID = "{item}">
                  {{ item.poID ? item.poID : '-' }}
                </template>
                <template v-slot:item.b2b_shippingdetails_schools = "{item}">
                  {{ item.b2b_shippingdetails_schools[0] ? item.b2b_shippingdetails_schools[0].ShippingReferenceNo : '-' }}
                </template>
                <template v-slot:item.enquiry.studentFirstName = "{item}">
                  {{
                    item.enquiry
                      ? item.enquiry.studentFirstName
                      : item.studentAdmission
                      ? item.studentAdmission.studentEnrollment.studentName
                      : '-'
                  }}
                </template>
                <template v-slot:item.enrollmentCode = "{item}">
                  {{
                    item.enquiry
                      ? item.enquiry.enrollmentCode
                      : item.studentAdmission
                      ? item.studentAdmission.studentEnrollment.enrollmentCode
                      : '-'
                  }}
                </template>
                <template v-slot:item.enquiry.enquiryCode = "{item}">
                  {{ item.enquiry ? item.enquiry.enquiryCode : '-' }}
                </template>
                <template v-slot:item.amount = "{item}">
                  <v-icon small>mdi-currency-inr</v-icon> {{ Number(item.amount).toFixed(2) }}
                </template>
                <template v-slot:item.kit.subscriptionMonth = "{item}">
                  {{ item.kit ? item.kit.subscriptionMonth + 1 : '-' }}
                </template>
                <template v-slot:item.status = "{item}">
                  <span :class="getColor(item.status)">{{ item.status }}</span>
                </template>
                <template v-slot:item.kit.studentClass.name = "{item}">
                  {{
                    item.kit
                    ? item.kit.studentClass.name
                    : item.enquiry
                    ? item.enquiry.studentClasses.name || '-'
                    : item.studentAdmission
                    ? item.studentAdmission.class
                    : '-'
                  }}
                </template>
                <template v-slot:item.isServiceable = "{item}">
                  {{ item.isServiceable ? 'Yes' : 'No' }}
                </template>
                <template v-slot:item.orderTime = "{item}">
                  {{ new Date(item.orderTime).toLocaleDateString() }}
                </template>
                <template v-slot:item.B2B_ShippingDetails[0].ShipOutDate="{ item }">
                  {{item.B2B_ShippingDetails?.[0]?.ShipOutDate ?
                    new Date(item.B2B_ShippingDetails[0].ShipOutDate).toLocaleDateString(): '-' }}
                </template>
                <template v-slot:item.B2B_ShippingDetails[0].Estimated_Delivery_DateTime="{ item }">
                  {{item.B2B_ShippingDetails?.[0]?.Estimated_Delivery_DateTime ?
                    new Date(item.B2B_ShippingDetails[0].Estimated_Delivery_DateTime).toLocaleDateString(): '-'}}
                </template>
                <template v-slot:item.action = "{item}">
                  <v-btn
                    class="mr-2"
                    icon
                    color="#1976D2"
                    x-small
                    title="View Order details"
                    :to="{
                      name: 'KitOrderDetails',
                      params: {
                        kitType,
                        orderID: item.orderID,
                        status: item.status
                      }
                    }"
                  >
                    <v-icon>mdi-eye</v-icon>
                  </v-btn>
                  <v-btn
                    :disabled="item.kitType == 'CURRICULUM_KIT_2'"
                    class="mr-2"
                    icon
                    color="#ff3939"
                    x-small
                    title="Cancel Order"
                    v-if="modules.cancelOrders && item.status == 'PENDING'"
                    @click="cancelOrder(item.orderID, (isCancelled = true))"
                  >
                    <v-icon>mdi-cancel</v-icon>
                  </v-btn>
                  <v-btn
                    :disabled="item.kitType == 'CURRICULUM_KIT_2'"
                    class="mr-2"
                    icon
                    color="#00cae3"
                    x-small
                    title="Re Order"
                    v-if="modules.cancelOrders && item.status == 'CANCELLED'"
                    @click="cancelOrder(item.orderID, (isCancelled = false))"
                  >
                    <v-icon>mdi-restore</v-icon>
                  </v-btn>
                  <v-btn
                    icon
                    color="#00cae3"
                    x-small
                    title="Track Order"
                    v-if="item.b2b_shippingdetails_schools && !checkEmpty( getImplodeShipping(item.b2b_shippingdetails_schools))"
                    :to="{
                      name: 'KitOrderTrack',
                      params: {
                        kitType,
                        orderID: item.orderID,
                        ShippingReferenceNo: getImplodeShipping(
                          item.b2b_shippingdetails_schools
                        )
                      }
                    }"
                  >
                    <v-icon>mdi-truck-delivery</v-icon>
                  </v-btn>
                </template>
              </v-data-table>
            </div>
          </v-col>
        </v-row>
      </v-card>
    </v-container>
  </div>
</template>

<script>
// @ is an alias to /src
import constants from '@/utils/constants'
import helper from '@/utils/helper'
import _ from 'lodash'
import { mapGetters } from 'vuex'
import Utils from '@/utils'
import moment from 'moment'
export default {
  name: 'orderHistoryKitType',
  props: ['kitType'],
  data () {
    return {
      modules: {
        cancelOrders: this.checkModuleAccess('cancelOrders')
      },
      fromDateMenu: false,
      toDateMenu: false,
      searchTerm: '',
      inProgress: false,
      constantKit: constants.KIT,
      data: [],
      total: 0,
      current: 1,
      rangeBefore: 3,
      rangeAfter: 1,
      order: 'is-right',
      size: '',
      isSimple: false,
      isRounded: false,
      prevIcon: 'chevron-left',
      nextIcon: 'chevron-right',
      isModalActive: false,
      trashObject: null,
      isLoading: false,
      totalstudents: '',
      checkedRows: [],
      orderhistoryData: [],
      franchiseeArr: [],
      enableFilterModal: false,
      loadingComponent: null,
      searchFilterArray: [],
      kit: {},
      filter: {
        kitType: '',
        franchiseeID: '',
        orderID: '',
        status: '',
        orderFromDate: moment().format('YYYY-MM-DD'),
        orderToDate: moment().format('YYYY-MM-DD')
      },
      currentDate: moment().format('YYYY-MM-DD'),
      // filterFromDate: this.formatDate(new Date().toISOString().slice(0, 10)),
      // filterToDate: this.formatDate(new Date().toISOString().slice(0, 10)),
      filterFromDate: moment().format('DD/MM/YYYY'),
      filterToDate: moment().format('DD/MM/YYYY'),
      maxToDate: moment().format('DD/MM/YYYY'),
      statusList: [
        { name: 'ALL', value: '' },
        { name: 'FAIL', value: 'FAIL' },
        { name: 'PENDING', value: 'PENDING' },
        { name: 'SHIPPED', value: 'SHIPPED' },
        { name: 'CONFIRMED', value: 'CONFIRMED' },
        { name: 'DELIVERED', value: 'DELIVERED' },
        { name: 'CANCELLED', value: 'CANCELLED' }
      ],
      itemsPerPageOption: [20, 40, 60, -1],
      perPageLimit: 20
    }
  },
  async created () {
    const fromDate = new Date(new Date().setMonth(new Date().getMonth() - 1))
    this.filter.orderFromDate = fromDate.toISOString().slice(0, 10)
    this.kit = _.find(this.constantKit, (item) =>
      _.isEqual(item.route, this.kitType)
    )
    if (_.isEmpty(this.kit)) {
      this.$router.push({ name: 'orderHistory' })
    }
    this.filter.kitType = this.kit.id
    this.filter.alternateKitType = this.kit.alternateID
    await this.onFranchiseeChange()
  },
  mounted: async function () {
    await this.onFranchiseeChange()
  },
  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee'
    })
  },
  watch: {
    franchisee: async function (val) {
      await this.onFranchiseeChange()
    },
    'filter.orderFromDate': function (val) {
      this.filterFromDate = this.formatDate(val)
    },
    'filter.orderToDate': function (val) {
      this.filterToDate = this.formatDate(val)
    }
  },
  methods: {
    checkTotalResultCount: function (pagination) {
      this.total = pagination.itemsLength
    },
    formatDate (date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    parseDate (date) {
      if (!date) return null

      const [month, day, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    checkModuleAccess: function (moduleName) {
      return Utils.helper.checkAccessByModule(this.$route, moduleName)
    },
    cancelOrder: async function (orderID, isCancelled) {
      let message = ''
      if (isCancelled) {
        message = 'Are you sure you want to cancel this order?'
      } else {
        message = 'Are you sure you want to reorder this order?'
      }
      this.$dialog.confirm({
        title: 'Confirm Order',
        text: message,
        type: isCancelled ? 'error' : 'info',
        actions: {
          false: {
            text: 'No',
            handle: () => {
              this.$nextTick(() => {
                return false
              })
            }
          },
          true: {
            color: isCancelled ? 'error' : 'info',
            text: 'Yes',
            handle: async () => {
              try {
                this.isLoading = true
                let payLoad = {
                  orderID: orderID
                }
                let res = await http.patch(
                  `${constants.API_URL}/api/order/cancel`,
                  payLoad
                )
                console.log(res, 'res')
                this.okMsg(
                  isCancelled
                    ? 'Order Cancelled successfully!'
                    : 'Order Restored successfully!'
                )
                this.getOrderHistory()
              } catch (e) {
                const errorMessage =
                  (e && e.response && e.response.data.message) || e.message

                this.errMsg(errorMessage)
              } finally {
                this.isLoading = false
              }
            }
          }
        }
      })
    },
    okMsg (msg) {
      return this.$dialog.info({
        title: 'Success',
        text: msg
      })
    },
    errMsg (msg) {
      return this.$buefy.dialog.alert({
        message: msg,
        type: 'is-danger',
        hasIcon: true,
        animation: 'zoom-out',
        size: 'is-medium',
        icon: ' mdi-exclamation',
        iconPack: 'mdi',
        ariaRole: 'alertdialog',
        ariaModal: true
      })
    },
    onFranchiseeChange: async function () {
      try {
        if (!this.inProgress) {
          this.inProgress = true
          if (this.franchisee) {
            this.filter.franchiseeID = this.franchisee.id
          } else {
            this.filter.franchiseeID = ''
            this.orderhistoryData = []
          }
          if (!this.filter.franchiseeID) {
            Utils.helper.openDrawer(this)
          }
          await this.getOrderHistory()
        }
      } finally {
        this.inProgress = false
      }
    },
    customSearch (value, search, item) {
      return (item && item.orderID.toLowerCase().includes(search.toLowerCase())) ||
      (item && item.studentAdmission && item.studentAdmission.studentEnrollment.studentName.toLowerCase().includes(search.toLowerCase())) ||
      (item && item.studentAdmission && item.studentAdmission.studentEnrollment.enrollmentCode.toLowerCase().includes(search.toLowerCase())) ||
      (item && item.status.toLowerCase().includes(search.toLowerCase())) ||
      (item && item.studentAdmission && item.studentAdmission.class.toLowerCase().includes(search.toLowerCase())) ||
      (item && item.kit && item.kit.studentClass && item.kit.studentClass.name.toLowerCase().includes(search.toLowerCase())) ||
      (item && item.enquiry && item.enquiry.studentClass.name.toLowerCase().includes(search.toLowerCase())) ||
      (item && item.enquiry && item.enquiry.enquiryCode.toLowerCase().includes(search.toLowerCase())) ||
      (item && item.enquiry && item.enquiry.studentFirstName.toLowerCase().includes(search.toLowerCase())) ||
      (item && item.orderTime.toLowerCase().includes(search.toLowerCase())) ||
      (item && item.enquiry && item.enquiry.enrollmentCode && item.enquiry.enrollmentCode.toString().toLowerCase().includes(search.toLowerCase())) ||
      (item && item.amount.toLowerCase().includes(search.toLowerCase()))
    },
    getImplodeShipping: function (value) {
      if (value && value.length > 0) {
        let result = _.reject(_.map(value, 'ShippingReferenceNo'), _.isEmpty)
        return _.isArray(result) ? result.join(',') : ''
      } else {
        return ''
      }
    },
    checkEmpty: function (data) {
      return _.isEmpty(data)
    },
    getTag (status) {
      return helper.getClass(status)
    },
    generateHeader: function (orderHistoryData) {
      this.headers = [
        { text: 'Previous/ReOrder ID', value: 'preOrder', align: 'left' },
        { text: 'Order ID', value: 'orderID', align: 'left' },
        { text: 'POID', value: 'poID', align: 'left' },
        { text: 'AWB', value: 'b2b_shippingdetails_schools', align: 'left' }
      ]
      if (
        this.kitType === 'student-kit-1' || this.kitType === 'student-kit-2' ||
          this.kitType === 'intelli-kit' || this.kitType === 'gift-box' ||
          this.kitType === 'damage-missing-kit' || this.kitType === 'bridge-kit'
      ) {
        this.headers.push(
          { text: 'Student Name', value: 'enquiry.studentFirstName', align: 'left' }
        )
      }
      if (
        this.kitType === 'student-kit-1' || this.kitType === 'student-kit-2' ||
          this.kitType === 'intelli-kit' || this.kitType === 'gift-box' ||
          this.kitType === 'damage-missing-kit'
      ) {
        this.headers.push(
          { text: 'Enrollment Code', value: 'enrollmentCode', align: 'left' }
        )
      }
      if (this.kitType === 'gift-box' || this.kitType === 'damage-missing-kit') {
        this.headers.push(
          { text: 'Enquiry Code', value: 'enquiry.enquiryCode', align: 'left' }
        )
      }
      this.headers.push(
        { text: 'Order Amount', width: '150px', value: 'amount', align: 'left' },
        { text: 'Month', value: 'kit.subscriptionMonth', align: 'left' },
        { text: 'Order status', value: 'status', align: 'left' },
        { text: 'BOM name', value: 'kitSetMap.name', align: 'left' },
        { text: 'EDD', value: 'B2B_ShippingDetails[0].Estimated_Delivery_DateTime', align: 'left' },
        { text: 'EDS', value: 'B2B_ShippingDetails[0].ShipOutDate', align: 'left' },
        { text: 'Service Provider Name', value: 'B2B_ShippingDetails[0].ShippingCompany', align: 'left' }
      )
      let classHeaderFlag = false
      orderHistoryData.forEach(item => {
        if (item.kit && item.kit.studentClass && item.kit.studentClass.name && !classHeaderFlag) {
          this.headers.push(
            { text: 'Class', value: 'kit.studentClass.name', align: 'left' }
          )
          classHeaderFlag = true
        }
      })
      this.headers.push(
        { text: 'Is Serviceable', value: 'isServiceable', align: 'left' },
        { text: 'Order Date', value: 'orderTime', align: 'left' },
        { text: 'Action', width: '100px', value: 'action', align: 'left' }
      )
    },
    getOrderHistory: async function () {
      try {
        this.headers = []
        if (!this.filter.franchiseeID) {
          return
        }
        this.loadingComponent = this.$buefy.loading.open()
        let start = moment(this.filter.orderFromDate, 'YYYY-MM-DD').utcOffset(0, true)
        start = start.startOf('day')
        let end = moment(this.filter.orderToDate, 'YYYY-MM-DD').utcOffset(0, true)
        end = end.endOf('day')
        const response = await http.post(
          `${constants.API_URL}/api/order/details`,
          Object.assign({}, this.filter, {
            orderFromDate: start,
            orderToDate: end
          })
        )

        this.loadingComponent.close()
        if (
          !_.isEmpty(response.data.rows) &&
          response.data.rows !== 'undefined'
        ) {
          this.orderhistoryData = response.data.rows
          this.searchFilterArray = this.orderhistoryData
        } else {
          this.searchFilterArray = []
        }
        this.generateHeader(this.searchFilterArray)
        this.studentDetails = this.searchFilterArray.studentAdmission
          ? this.searchFilterArray.studentAdmission
          : this.searchFilterArray.enquiry

        this.enableFilterModal = false
      } catch (e) {
        this.loadingComponent.close()
        this.enableFilterModal = false
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        console.log('Error While Fetching Order history', errorMessage)
        this.lock = false
        this.hasClicked = false
        return this.$buefy.dialog.alert({
          message: errorMessage,
          type: 'is-danger',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    resetAll: async function () {
      this.filter = {
        kitType: this.kit.id,
        orderID: '',
        status: '',
        orderFromDate: moment().format('DD/MM/YYYY'),
        orderToDate: moment().format('DD/MM/YYYY')
      }
      // this.filterFromDate = this.formatDate(new Date().toISOString().slice(0, 10))
      // this.filterToDate = this.formatDate(new Date().toISOString().slice(0, 10))
      this.filterFromDate = moment().format('DD/MM/YYYY')
      this.filterToDate = moment().format('DD/MM/YYYY')
      if (this.franchisee) {
        this.filter.franchiseeID = this.franchisee.id
      } else {
        this.filter.franchiseeID = ''
      }
      const fromDate = new Date(new Date().setMonth(new Date().getMonth() - 1))
      this.filter.orderFromDate = fromDate.toISOString().slice(0, 10)
      await this.onFranchiseeChange()
    },
    getColor: function (status) {
      return status === 'PENDING'
        ? 'light-blue--text text--darken-1'
        : status === 'FAIL'
          ? 'red--text text--darken-1'
          : status === 'CONFIRMED'
            ? 'deep-purple--text text--darken-1'
            : status === 'SHIPPED'
              ? 'pink--text text--darken-1'
              : status === 'DELIVERED'
                ? 'orange--text text--darken-2'
                : 'red--text text--darken-1'
    }
  }
}
</script>
<style scoped>
.delivery {
  background-color: #ffa535;
  color: black;
}
.shipped {
  background-color: #d44eec;
  color: black;
}
.confirm {
  background-color: #635ebe;
  color: white;
}
.v-data-table-container{
  width:100%;
  height:auto;
  overflow:hidden;
  overflow-x: auto;
}
</style>
